import { render, staticRenderFns } from "./pendingTasks.vue?vue&type=template&id=c0da63b6&scoped=true&"
import script from "./pendingTasks.vue?vue&type=script&lang=js&"
export * from "./pendingTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0da63b6",
  null
  
)

export default component.exports